"use strict";

exports.__esModule = true;
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var runFormValidation = function runFormValidation(formData, fieldValidation) {
  var fieldError = false;
  var fieldValidationResult = Object.keys(fieldValidation).reduce(function (errors, fieldName) {
    var _objectSpread2;

    var result = fieldValidation[fieldName]((0, _lodash.default)(formData, fieldName, ''), formData);

    if (result !== true) {
      fieldError = true;
    }

    return _objectSpread({}, errors, (_objectSpread2 = {}, _objectSpread2[fieldName] = result, _objectSpread2));
  }, {});
  return {
    fieldError: fieldError,
    fieldValidationResult: fieldValidationResult
  };
};

var _default = runFormValidation;
exports.default = _default;